
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-4 gap-12">
          {/* Brand & Contact */}
          <div>
            <h3 className="font-serif text-xl mb-6">Bighorn Family Dental</h3>
            <div className="space-y-4 text-white/80 text-sm">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-accent mt-1"></i>
                <div>825 Simms St, Golden, CO 80401</div>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-accent"></i>
                <a href="tel:2296519254" className="hover:text-white transition-colors cursor-pointer">
                  (229) 651-9254
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-accent"></i>
                <a href="mailto:info@bfdental.org" className="hover:text-white transition-colors cursor-pointer">
                  info@bfdental.org
                </a>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-accent transition-all cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-accent transition-all cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-accent transition-all cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-xl mb-6">Quick Links</h3>
            <div className="space-y-3 text-white/80 text-sm">
              <Link to="/" className="block hover:text-white transition-colors cursor-pointer">Home</Link>
              <Link to="/about" className="block hover:text-white transition-colors cursor-pointer">About Us</Link>
              <Link to="/services" className="block hover:text-white transition-colors cursor-pointer">Services</Link>
              <Link to="/pricing" className="block hover:text-white transition-colors cursor-pointer">Pricing</Link>
            </div>
          </div>

          {/* Map */}
          <div className="col-span-2">
            <div className="bg-white/10 rounded-lg overflow-hidden h-64">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.8944444444444!2d-105.1234567!3d39.7555555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDQ1JzIwLjAiTiAxMDXCsDA3JzI0LjQiVw!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Dental clinic location"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex items-center justify-between text-sm text-white/60">
          <div>© 2024 Bighorn Family Dental. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
